const styles = {
  root: {
    cursor: 'pointer',
  },
};

export default styles;
